import { cn as e } from "../../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { Popover as r } from "@base-ui/react/popover";
//#region src/popover/primitive/index.tsx
var i = t((e) => /* @__PURE__ */ n(r.Root, { ...e })), a = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Trigger, {
	ref: a,
	className: e("focus-visible:focus-ring-primary outline-none", t),
	...i
})), o = t((e, t) => /* @__PURE__ */ n(r.Portal, {
	ref: t,
	...e
})), s = t(({ className: t, sideOffset: i = 6, ...a }, o) => /* @__PURE__ */ n(r.Positioner, {
	ref: o,
	className: e("z-50", t),
	sideOffset: i,
	...a
})), c = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Popup, {
	ref: a,
	className: e("bg-bg-primary text-text-primary border-border-100 shadow-1 z-50 rounded-lg border outline-none", "max-w-[min(320px,var(--available-width))] min-w-13", t),
	...i
})), l = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Arrow, {
	ref: a,
	className: e("bg-bg-primary border-border-100 size-2 rotate-45 border", "data-[side=top]:-bottom-1 data-[side=top]:border-t-0 data-[side=top]:border-l-0", "data-[side=bottom]:-top-1 data-[side=bottom]:border-r-0 data-[side=bottom]:border-b-0", "data-[side=left]:-right-1 data-[side=left]:border-b-0 data-[side=left]:border-l-0", "data-[side=right]:-left-1 data-[side=right]:border-t-0 data-[side=right]:border-r-0", t),
	...i
})), u = t((e, t) => /* @__PURE__ */ n(r.Backdrop, {
	ref: t,
	...e
})), d = t((e, t) => /* @__PURE__ */ n(r.Title, {
	ref: t,
	...e
})), f = t((e, t) => /* @__PURE__ */ n(r.Description, {
	ref: t,
	...e
})), p = t((e, t) => /* @__PURE__ */ n(r.Close, {
	ref: t,
	...e
})), m = t((e, t) => /* @__PURE__ */ n(r.Viewport, {
	ref: t,
	...e
}));
i.displayName = "PopoverRoot", a.displayName = "PopoverTrigger", o.displayName = r.Portal.displayName, s.displayName = r.Positioner.displayName, c.displayName = r.Popup.displayName, l.displayName = r.Arrow.displayName, u.displayName = r.Backdrop.displayName, d.displayName = r.Title.displayName, f.displayName = r.Description.displayName, p.displayName = r.Close.displayName, m.displayName = r.Viewport.displayName;
var h = {
	Root: i,
	Trigger: a,
	Portal: o,
	Positioner: s,
	Popup: c,
	Arrow: l,
	Backdrop: u,
	Title: d,
	Description: f,
	Close: p,
	Viewport: m,
	createHandle: r.createHandle,
	Handle: r.Handle
};
//#endregion
export { h as Popover };
